<template>
  <a
    @click.prevent="switchLang()"
    class="langswitch uk-link-text uk-width-expand uk-flex uk-flex-middle"
  >
    <span class="uk-icon uk-margin-small-right" uk-icon="world"></span>
    <span class="" v-t="getLang"></span>
  </a>
</template>

<script>
export default {
  name: 'LangSwitcher',
  i18n: {
    messages: {
      en: { en: 'English', de: 'German' },
      de: { en: 'Englisch', de: 'Deutsch' },
    },
  },
  methods: {
    switchLang() {
      // change locale
      this.$root.$i18n.locale = this.$root.$i18n.locale === 'de' ? 'en' : 'de';

      // update route
      //this.$router.replace({ params: { lang: this.$i18n.locale } });
    },
  },
  computed: {
    getLang() {
      return this.$i18n.locale === 'de' ? 'de' : 'en';
    },
  },
};
</script>

<style scoped>
.langswitch {
  text-transform: capitalize;
}
</style>
